/*
 * 模块名称: 保险公司结算页面
 * 创建人: DrugsZ 
 * 创建时间: 2018-01-05 11:02:49 
 * 修改人:DrugsZ 
 * 最后修改时间: 2018-01-05 11:02:49 
 */
<template>
   <div class="wrapper-content animated fadeInRight tabBox" id="ac-to-group" v-loading="loadingstatus" element-loading-text="加载中">
      <div class="ibox-content">
          <div class="form-horizontal">
              <div class="form-group">
                  <label class="col-sm-1 control-label">结算时间范围(起)</label>
                  <div class="col-sm-2">
                      <datepicker class="form-control" v-model="queryParam.startTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
                  <label class="col-sm-1 control-label">结算时间范围(止)</label>
                  <div class="col-sm-2">
                      <datepicker class="form-control"  v-model="queryParam.endTime"></datepicker>
                      <p v-if="!validDates" class="cus_message form-group__message">开始时间不得大于结束时间</p>
                  </div>
              </div>
              <div class="form-group">
                  <label for="" class="col-sm-1 control-labe t_right">结算说明</label>
                  <div class="col-sm-11">
                      <textarea  class="form-control" rows="4"  v-model="queryParam.memo"></textarea>
                  </div>
              </div>
              <div class="form-group">
                  <div class="col-sm-12 t_center">
                      <button class="btn btn-primary" @click="getClosing">收款清账</button>                      
                  </div>
              </div>
          </div>
          <account-list @onerror="openModalMsg" ref="accountLsit"></account-list>
           <tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
      </div>
  </div>
</template>
<script>
    import AccountList from 'components/pages/accountcheck/AccountList'
    import classlist from 'util/classlist'
    import TabModal from 'components/common/TabModal'
    import Datepicker from 'components/common/datepicker/Datepicker'
    import { OPERATE_EXCEPTION} from 'static/message'


    export default{
        name:"PageAccountCheckTOGroup",
        components:{
            AccountList,
            TabModal,
            Datepicker
        },
        data(){
            return{
                queryParam:{
                    startTime:'',
                    endTime:'',
                    memo:'',
                    type:2
                },
                loadingstatus:false,
                messageStr:'',
                scrollTop:'0'
            }
        },
         computed: {
			//	起止时间是否合法
			validDates: function(){
				if(this.queryParam.startTime && this.queryParam.endTime && this.queryParam.startTime > this.queryParam.endTime){
					return false;
				} else {
					return true;
				}
			}
		},
        methods:{
            getClosing(){
                this.loadingstatus = true;
                 this.$http.post(process.env.API_INSURANCE_ROOT+'/rescue-api/cost/platform/settle',this.queryParam)
                .then(res=>{
                    if(res.body.success){
                        this.openModalMsg('操作成功')
                        this.queryParam.startTime = '';
                        this.queryParam.endTime = '';
                        this.queryParam.memo = '';
                        this.$refs.accountLsit.loadData();
                    }else{
                        this.openModalMsg(res.body.message)
                    }
                    this.loadingstatus = false;
                },res=>{
                    this.loadingstatus = false;
                    this.openModalMsg(res.body.message);                    
                }).catch(res=>{
                    this.loadingstatus = false;
                    this.openModalMsg(OPERATE_EXCEPTION);                    
                })
            },
            closeModalMsg(){
                this.$refs.modalMsg.close()
                classlist.toggleScroll('open','#ac-to-group',this);
            },
            openModalMsg(msg){
                this.$refs.modalMsg.open()
                this.messageStr = msg
                classlist.toggleScroll('close','#ac-to-group',this);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// PageAccountCheckToGroup.vue?9255fdbc